export { default } from './Login';
export { default as template } from './login.tpl';
